import { render, staticRenderFns } from "./adrefule.vue?vue&type=template&id=336b36b3&scoped=true"
import script from "./adrefule.vue?vue&type=script&lang=js"
export * from "./adrefule.vue?vue&type=script&lang=js"
import style0 from "./adrefule.vue?vue&type=style&index=0&id=336b36b3&prod&lang=css"
import style1 from "./adrefule.vue?vue&type=style&index=1&id=336b36b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336b36b3",
  null
  
)

export default component.exports